<style scoped>
.attendance-config-content{
  height: calc(100vh - 28rem);
  overflow-y: auto;
  border: 1px solid rgba(207, 212, 232, 0.5);
  border-radius: 5px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.settings-parameter-container .groupForm_type {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.settings-parameter-container .groupForm_type .groupForm_type_single {
  padding: 5px 10px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-right: 0.9375rem;
  width: 13.75rem;
  cursor: pointer;
  position: relative;
  height: 6rem;
  border-radius: 0.375rem 0.375rem 0.375rem 0.375rem;
  border: 0.0625rem solid #d0d0d0;
  padding: 10px;
}

.settings-parameter-container .groupForm_type .groupForm_type_single .groupForm_type_single_title {
  font-size: 1rem;
  font-weight: bold;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
}

.settings-parameter-container .groupForm_type .groupForm_type_single .groupForm_type_single_tips {
  font-size: 0.75rem;
  color: #9196b1;
}


.settings-parameter-container .groupForm_type .groupForm_type_single_select {
  background: #e8f4ff;
  border-color: #0058ff;
}

.settings-parameter-container .groupForm_type .groupForm_type_single_select .groupForm_type_icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 2.0625rem;
  height: 2.0625rem;
}

.standard-edition-notice{
  color: #E6A23C!important;
  margin-top: 5px;
}
.attendance-setting-params{
  display: flex;
  justify-content: space-between;
}

.attendance-qrcode-content .attendance-qrcode-kmjy img{
  width: 100px;
  height: 100px;
}
.flex-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.centered-box {
  padding: 15px;
  background: #fbfdfd;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  text-align: center;
  width: 200px;
  height: 200px;
}
.flex-container .centered-box img{
  width: 142px;
  height: 142px;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  padding: 2px;
}
.flex-container .centered-box .centered-text{
  font-size: 12px;
}
</style>
<style>
.attendance-container .custom-checkbox{
  padding: 0.3925rem 0.9375rem 0.3125rem 0.625rem!important;
}
</style>
<template>
  <div class="attendance-container">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="" prop="status" label-width="0">
        <div style="display: flex; justify-content: space-between">
          <div style="display: flex; justify-content: space-between;">
            <el-checkbox v-model="ruleForm.status" @change="updateMessagePushConfig" class="custom-checkbox" :true-label="1" :false-label="0" border>开启考勤通知</el-checkbox>
          </div>
<!--          <div style="float: right" v-if="ruleForm.status == 1">
            <el-button type="primary" icon="el-icon-edit"> 保存</el-button>
          </div>-->
        </div>
      </el-form-item>

      <div class="attendance-config-content" v-if="ruleForm.status == 1">
        <div style="width: 100%">
          <div class="attendance-setting-params">
            <div class="settings-parameter-container">
              <div data-v-344cbe9a="" class="groupForm_type">
                <div @click="changeEnableDailyReport()"
                     :class="ruleForm.enableDailyReport == 1?'groupForm_type_single groupForm_type_single_select':'groupForm_type_single'">
                  <img v-if="ruleForm.enableDailyReport == 1" data-v-344cbe9a="" class="groupForm_type_icon"
                       src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAA0hJREFUeF7t10tIFVEYwPH/FAZiCaZCRElBroxIIrCQilwIRUSLyAgk2lWLiKDQyleQ4CYKTFoUFRiKPTEIyUf0AAuCErOFYSUEIRkolZDoxGkC71zn3pm5d96ns7tw7pnz/eb7zndGoUKtA2qJ/phEZQiFIeAhbcq92JCVvz8qVAEhQOQZKo+YZT8dyoQIWoOQFQMG+MkmOpVfcxAahixlEpv5N2hTDuohZM2MGTbPh5AxM1SuGEPIlhkqg4khZMoMlYnkEBJhmENIgmENQgIM6xAhxchdDOM/zC/M9iBChCECaz4EO4phaz18/pYcwz5ECDAWKHDzCBwo1YL/8h221MPIWGKM1CACjJGxENqPwZ6N+qDffILiKjcgAoiRmQGdJ6FsrT7gj2OwrQFGx92CCBBGdiZ0VUFJoT7Y4a9QWgtjk26cEfFr+vzVKjpD71lYV6Df2MAobD/nVtdIBOsTxvIceFIDhcv0G+sfhvJGmJwyb51iRuqHpdH6HmOsztcQCvL0m+kZhF1NMDVtDcF5CAfODFHrJ3ZCwx2YURMHIsqg+zTkZ+vn3H0FFZdgesY6gjsQaWDkZEHvGVi/Cm6/hH0XYdYAo2QNdFWDQIsdrc+h8rLxf8xYnC2N2KfZLJO8JVqaF62YW8QosLIirUVmLtKH1vIYjl6DJEmU1MI9CJuZYQQhlojF2L0BOo6DuDTFjsb7UN1u9s69aJ/JnmEjM5ZmQV/N/DZ4tQ+evofrh0GJe3WnbkFTZ3oI7p0R8fuygSHOiWd1+hIxClNVtVJo6U4fwTsIm2VihiEO0MpmaH3hDIK3EA5hiLa49wI8eO0cgvcQaWJM/dYuSj3vnEXwByJFjJW5UH4e+j84j+AfhE0M0U0ExNtRdxD8hbCJ4R6BtrK7Fyoru7fRWq0sl+oc/yECkhnBgAgARnAgfMYIFoSPGMGD8AkjmBA+YAQXwmOMYEN4iBF8CI8wwgHhAUZ4IFzGCBeEixjhg3AJI5wQLmCEF8JhjHBDOIgRfgiHMKIB4QBGdCDSxIgWRBoY0YNIESOaEClgRBfCJka0IWxgRB/CIoYcEBYw5IEwwZALIgmGfBAJMOSEMMCQFyIOQ26IGIz/EP8w/gDUgS85M3pMxgAAAABJRU5ErkJggg==">
                  <div data-v-344cbe9a="" class="groupForm_type_single_title">日报表</div>
                  <div data-v-344cbe9a="" class="groupForm_type_single_tips"> 日报表每天统计前一天数据，并发送到管理员微信，需关注「 科密巨源 」微信公众号</div>
                </div>
                <div @click="changeEnableMonthlyReport()"
                     :class="ruleForm.enableMonthlyReport == 1?'groupForm_type_single groupForm_type_single_select':'groupForm_type_single'">
                  <!---->
                  <img v-if="ruleForm.enableMonthlyReport == 1" data-v-344cbe9a="" class="groupForm_type_icon"
                       src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAADjVADoAAAAAXNSR0IArs4c6QAAA0hJREFUeF7t10tIFVEYwPH/FAZiCaZCRElBroxIIrCQilwIRUSLyAgk2lWLiKDQyleQ4CYKTFoUFRiKPTEIyUf0AAuCErOFYSUEIRkolZDoxGkC71zn3pm5d96ns7tw7pnz/eb7zndGoUKtA2qJ/phEZQiFIeAhbcq92JCVvz8qVAEhQOQZKo+YZT8dyoQIWoOQFQMG+MkmOpVfcxAahixlEpv5N2hTDuohZM2MGTbPh5AxM1SuGEPIlhkqg4khZMoMlYnkEBJhmENIgmENQgIM6xAhxchdDOM/zC/M9iBChCECaz4EO4phaz18/pYcwz5ECDAWKHDzCBwo1YL/8h221MPIWGKM1CACjJGxENqPwZ6N+qDffILiKjcgAoiRmQGdJ6FsrT7gj2OwrQFGx92CCBBGdiZ0VUFJoT7Y4a9QWgtjk26cEfFr+vzVKjpD71lYV6Df2MAobD/nVtdIBOsTxvIceFIDhcv0G+sfhvJGmJwyb51iRuqHpdH6HmOsztcQCvL0m+kZhF1NMDVtDcF5CAfODFHrJ3ZCwx2YURMHIsqg+zTkZ+vn3H0FFZdgesY6gjsQaWDkZEHvGVi/Cm6/hH0XYdYAo2QNdFWDQIsdrc+h8rLxf8xYnC2N2KfZLJO8JVqaF62YW8QosLIirUVmLtKH1vIYjl6DJEmU1MI9CJuZYQQhlojF2L0BOo6DuDTFjsb7UN1u9s69aJ/JnmEjM5ZmQV/N/DZ4tQ+evofrh0GJe3WnbkFTZ3oI7p0R8fuygSHOiWd1+hIxClNVtVJo6U4fwTsIm2VihiEO0MpmaH3hDIK3EA5hiLa49wI8eO0cgvcQaWJM/dYuSj3vnEXwByJFjJW5UH4e+j84j+AfhE0M0U0ExNtRdxD8hbCJ4R6BtrK7Fyoru7fRWq0sl+oc/yECkhnBgAgARnAgfMYIFoSPGMGD8AkjmBA+YAQXwmOMYEN4iBF8CI8wwgHhAUZ4IFzGCBeEixjhg3AJI5wQLmCEF8JhjHBDOIgRfgiHMKIB4QBGdCDSxIgWRBoY0YNIESOaEClgRBfCJka0IWxgRB/CIoYcEBYw5IEwwZALIgmGfBAJMOSEMMCQFyIOQ26IGIz/EP8w/gDUgS85M3pMxgAAAABJRU5ErkJggg==">
                  <div data-v-344cbe9a="" class="groupForm_type_single_title">月报表</div>
                  <div data-v-344cbe9a="" class="groupForm_type_single_tips"> 月报表每月1号统计前一个月数据，并发送到管理员微信，需关注「 科密巨源 」微信公众号</div>
                </div>
              </div>
            </div>
            <div style="width: 100%">
              <el-alert :closable="false"
                        title="1、接收考勤通知需关注「科密巨源」微信公众号，登陆科密云平台或「科密易考勤」绑定微信。"
                        type="warning">
              </el-alert>
              <el-alert :closable="false" style="margin-top: 5px;"
                  title="2、管理员考勤通知统计全企业人员数据"
                  type="warning">
              </el-alert>
              <el-alert :closable="false" style="margin-top: 5px;"
                  title="3、部门考勤通知统计当前部门人员数据"
                  type="warning">
              </el-alert>
            </div>
          </div>
          <el-row style="margin-top: 20px" :gutter="20">
            <el-col :span="12">
              <el-card header="管理员考勤通知" shadow="never">
                <div slot="header" class="clearfix">
                  <span>管理员考勤通知</span>
                  <el-button style="float: right; " size="mini" type="primary" @click="handleAdminEdit">编辑</el-button>
                </div>
                <el-table
                    :data="adminReportList"
                    height="calc(100vh - 41rem)"
                    size="mini"
                    style="width: 100%">
                  <el-table-column
                      prop="name"
                      label="人员">
                  </el-table-column>
                  <el-table-column
                      prop="deptName"
                      label="所属部门">
                  </el-table-column>
                  <el-table-column
                      prop="oper" width="60" align="center"
                      label="操作">
                    <template slot-scope="{row}">
                      <el-popconfirm title="您确定删除吗？" @confirm="deleteAdminReport(row.id)">
                        <el-button slot="reference" type="text" style="color:#F56C6C" >删除</el-button>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card header="部门考勤通知" shadow="never">
                <div slot="header" class="clearfix">
                  <span>部门考勤通知</span>
                  <el-button style="float: right; " size="mini" type="primary" @click="handleDeptEdit">编辑</el-button>
                </div>
                <el-table
                    ref="messagePushDeptTableRef"
                    :data="deptData" row-key="id"
                    @selection-change="handleSelectionDeptChange"
                    height="calc(100vh - 41rem)"
                    default-expand-all
                    size="mini" :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                    style="width: 100%">
                  <el-table-column
                      type="selection"
                      align="center"
                      width="50">
                  </el-table-column>
                  <el-table-column
                      prop="name"
                      label="部门名称">
                  </el-table-column>
                  <el-table-column
                      prop="count" align="center"
                      label="通知人数" width="90">
                  </el-table-column>
                  <el-table-column
                      prop="oper" width="60" align="center"
                      label="操作">
                    <template slot-scope="{row}">
                      <el-popover
                          placement="top"
                          width="400" @show="getMessagePushDeptList(row.id)"
                          trigger="click">
                        <el-table :data="deptReportList" height="200" size="mini">
                          <el-table-column
                              type="selection"
                              align="center"
                              width="50">
                          </el-table-column>
                          <el-table-column
                              prop="name"
                              label="人员">
                          </el-table-column>
                          <el-table-column
                              prop="deptName"
                              label="所属部门">
                          </el-table-column>
                          <el-table-column
                              prop="oper" width="60" align="center"
                              label="操作">
                            <template slot-scope="scope">
                              <el-popconfirm title="您确定删除吗？" @confirm="deleteDeptReport(row.id, scope.row.id)">
                                <el-button slot="reference" type="text" style="color:#F56C6C" >删除</el-button>
                              </el-popconfirm>
                            </template>
                          </el-table-column>
                        </el-table>
                        <el-button slot="reference" type="text" style="color:#409EFF" size="mini">详情</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div style="width: 240px;margin-left: 50px">
          <div class="flex-container">
            <div class="centered-box">
              <div class="centered-text" style="margin: 5px 0;font-weight: bold">「 科密巨源 」</div>
              <img src="@/assets/qrcode/kmjy_mp.jpg">
              <div class="centered-text" style="margin-top: 2px">扫码二维码关注公众号</div>
            </div>
          </div>

          <div class="flex-container" style="margin-top: 50px">
            <div class="centered-box">
              <div class="centered-text" style="margin: 5px 0;font-weight: bold">「 科密易考勤 」</div>
              <img src="@/assets/qrcode/etime.png">
              <div class="centered-text" style="margin-top: 2px">扫码二维码登陆小程序</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="ruleForm.status == 0" style="display: flex;justify-content: start;align-items: center;margin-top: 50px;">
        <div class="flex-container">
          <div class="centered-box">
            <div class="centered-text" style="margin: 5px 0;font-weight: bold">「 科密巨源 」</div>
            <img src="@/assets/qrcode/kmjy_mp.jpg">
            <div class="centered-text" style="margin-top: 2px">扫码二维码关注公众号</div>
          </div>
        </div>

        <div class="flex-container" style="margin-left: 50px">
          <div class="centered-box">
            <div class="centered-text" style="margin: 5px 0;font-weight: bold">「 科密易考勤 」</div>
            <img src="@/assets/qrcode/etime.png">
            <div class="centered-text" style="margin-top: 2px">扫码二维码登陆小程序</div>
          </div>
        </div>
      </div>
    </el-form>

    <admin-notification-dialog ref="adminNotificationDialogRef" @success="getMessagePushAdminList"/>
    <dept-notification-dialog ref="deptNotificationDialogRef" @success="getMessagePushDeptTree"/>
  </div>
</template>


<script>
//考勤通知
import AdminNotificationDialog from "@/views/account/setting/components/admin-notification-dialog.vue";
import DeptNotificationDialog from "@/views/account/setting/components/dept-notification-dialog.vue";
import {MessagePushConfigurationApi} from '@/api/server/messagePushConfiguration';
import {MessagePushAdminApi} from '@/api/server/messagePushAdmin';
import {MessagePushDeptApi} from '@/api/server/messagePushDept';
export default {
  components: {
    AdminNotificationDialog,
    DeptNotificationDialog
  },
  data() {
    return {
      ruleForm: {
        status: 0,
        reportType: [],
        enableDailyReport: 1,
        enableMonthlyReport: 1
      },
      rules: {
        status: [
          {required: true, message: '请输入活动名称', trigger: 'blur'},
        ],
      },
      reportTypeList: [
        {value: 1, label: '日报表'},
        {value: 2, label: '月报表'}
      ],
      adminReportList:[],
      selectedDeptId: null,
      deptData:[],
      deptReportList:[],
    };
  },
  watch: {

  },
  async created() {
    this.getMessagePushConfig();
    this.getMessagePushAdminList();
    this.getMessagePushDeptTree();
  },
  mounted() {

  },
  methods: {
    changeEnableDailyReport(){
      this.ruleForm.enableDailyReport = this.ruleForm.enableDailyReport == 1?0:1;
      this.updateMessagePushConfig();
    },
    changeEnableMonthlyReport(){
      this.ruleForm.enableMonthlyReport = this.ruleForm.enableMonthlyReport == 1?0:1;
      this.updateMessagePushConfig();
    },
    handleAdminEdit(){
      this.$refs?.adminNotificationDialogRef?.show();
    },
    getMessagePushConfig(){
      MessagePushConfigurationApi.getMessagePushConfigurationByCurrentCompany().then(res=>{
        const {code, data} = res;
        if(code == 200){
          this.ruleForm = data || {
            status: 0,
            reportType: [],
            enableDailyReport: 1,
            enableMonthlyReport: 1
          };
        }
      });
    },
    updateMessagePushConfig(){
      MessagePushConfigurationApi.updateMessagePushConfiguration(this.ruleForm).then(res=>{
        const {code, message} = res;
        if(code != 200){
          // this.$message.success('更新成功');
          this.$message.error(message);
        }
      });
    },
    getMessagePushAdminList(){
      MessagePushAdminApi.getMessagePushAdminListByCurrentCompany().then(res=>{
        const {code, data} = res;
        if(code == 200){
          this.adminReportList = data;
        }
      });
    },
    deleteAdminReport(id){
      MessagePushAdminApi.deleteMessagePushAdmin(id).then(res=>{
        const {code, message} = res;
        if(code == 200){
          this.$message.success('删除成功');
          this.getMessagePushAdminList();
        }else{
          this.$message.error(message);
        }
      });
    },
    getMessagePushDeptTree(){
      MessagePushDeptApi.getMessagePushDeptTree().then(res=>{
        const {code, data} = res;
        if(code == 200){
          this.deptData = data;
        }
      });
    },
    getMessagePushDeptList(deptId){
      MessagePushDeptApi.getMessagePushDeptListByCurrentCompany({deptId}).then(res=>{
        const {code, data} = res;
        if(code == 200){
          this.deptReportList = data;
        }
      });
    },
    handleSelectionDeptChange(selection){
      this.selectedDeptId= selection[0]?.id;
      if (selection.length > 1) {
        this.$refs.messagePushDeptTableRef.clearSelection();
        this.$refs.messagePushDeptTableRef.toggleRowSelection(selection.pop());
      }
    },
    handleDeptEdit(){
      if(this.selectedDeptId){
        this.$refs?.deptNotificationDialogRef?.show(this.selectedDeptId);
      }else{
        this.$message.error('请选择部门');
      }
    },
    deleteDeptReport(deptId, userId){
      MessagePushDeptApi.deleteMessagePushDept({deptId, userId}).then(res=>{
        const {code, message} = res;
        if(code == 200){
          this.$message.success('删除成功');
          this.getMessagePushDeptList(this.selectedDeptId);
          this.getMessagePushDeptTree();
        }else{
          this.$message.error(message);
        }
      });
    }
  }
};
</script>